module.exports = __webpack_public_path__ + "static/media/Realistic.ac6a5be1.svg";